import React from "react";
import "./Footer.css";

const Footer = (props) => {
  return (
    <div className="add-plan-footer">
      <button
        className="process-btn"
        onClick={(e) => props.handleProcessPlan(e)}
      >
        Process Plan
      </button>
    </div>
  );
};

export default Footer;
